import { Loading } from "@/components/Loading/Loading";
import { Sentry } from "@/sentry";
import { useAuth0 } from "@auth0/auth0-react";
import Text from "@ingka/text";
import { useEffect } from "react";
import { injectBearerToken } from "./services/api/axios-client";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const {
    isLoading,
    isAuthenticated,
    error,
    user,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname + window.location.search,
        },
      });
    }
  }, [isLoading, isAuthenticated, error, loginWithRedirect]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    return injectBearerToken(getAccessTokenSilently);
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    if (user?.email) {
      Sentry.setUser({ email: user.email });
    }
    return () => Sentry.setUser(null);
  }, [user]);

  if (error) {
    return (
      <Text className="mt-space1350 text-center text-xl">
        Authentication failed. Please refresh the page or{" "}
        <a href="https://jira.digital.ingka.com/servicedesk/customer/portal/16/create/7009">
          create a support ticket.
        </a>
      </Text>
    );
  }

  if (isLoading || !isAuthenticated) {
    return <Loading text="Authentication in progress..." />;
  }
  return <>{children}</>;
}
